






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapMutations } from "vuex";

@Component
export default class Password extends Vue {
    private loading = false;
    private editForm: any = {
        infoType: 3,
        data: ""
    };
    private pw = "";

    // 提交
    onSave() {
        if (this.editForm.data != this.pw) {

            this.$message({
                type: 'error',
                message: '两次密码不一致!'
            });
            return;
        }

        
        this.$apis.putUserInfo(this.editForm)
            .then((res: any) => {
                
                this.$store.state.needUpdatePassword = false;
                this.$message({
                    type: 'success',
                    message: '提交成功!'
                });                    
            });
    }
}
